import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9353fb8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "AI助手", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "云对话", -1))
const _hoisted_7 = {
  key: 0,
  src: "https://chatbot.weixin.qq.com/webapp/0Gu0Rk1Hn3qEYRjraKt5JNnBCmoQHi?isFloat=false&robotName=%E8%BD%BB%E9%A3%9F%E6%98%93%E5%AE%89%E6%99%BA%E8%83%BD%E5%AE%A2%E6%9C%8D",
  frameborder: "0",
  allowfullscreen: "true",
  webkitallowfullscreen: "true",
  mozallowfullscreen: "true",
  style: {"position":"absolute","width":"100%","height":"90%"}
}

import { ref, computed } from "vue";
import global1 from "@/assets/image/global-1.png";
import global2 from "@/assets/image/global-2.png";
import { message } from "ant-design-vue";
import { useRoute } from "vue-router";
import { useStore } from "@/store/store";

// const { createMessage } = useMessage();

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalFloatButton',
  setup(__props) {

const route = useRoute();
const store = useStore();

let containerDrawerVisible = ref(false);

// 配置需要隐藏 GlobalFloatButton 的路由路径
// const hiddenRoutes = [
//   "/login",
//   // 在这里添加更多需要隐藏的路径
// ];

// 悬浮按钮总开关：读取本地保存的扫码收货配置中的 floatEnabled，默认开启
const floatEnabled = computed(() => {
  const saved = store?.getScanReceivingConfig;
  const parsed =
    saved && typeof saved === "string" ? JSON.parse(saved) : saved || {};
  return parsed.floatEnabled === undefined ? true : !!parsed.floatEnabled;
});

// 判断当前路由是否应该显示 GlobalFloatButton
const shouldShow = computed(() => {
  // console.log(route.path, "route.path");
  // console.log(route.name, "route.path");
  // return !hiddenRoutes.some((path) => route.path.startsWith(path));
  return route.path !== "/" && floatEnabled.value;
});

// 拖拽相关状态
const isDragging = ref(false);
// 悬浮按钮位置本地存储 key
const FLOAT_POS_KEY = "global_float_btn_position";

// 读取上次保存的位置，没有则使用默认位置
function loadSavedPosition() {
  try {
    const saved = localStorage.getItem(FLOAT_POS_KEY);
    if (saved) {
      const pos = JSON.parse(saved);
      if (typeof pos.x === "number" && typeof pos.y === "number") {
        return { x: pos.x, y: pos.y };
      }
    }
  } catch (e) {
    // 忽略解析错误，使用默认位置
  }
  return {
    x: window.innerWidth - 86,
    y: window.innerHeight - 245,
  };
}

const btnPosition = ref(loadSavedPosition());
const dragStart = ref({ x: 0, y: 0 });
const startPos = ref({ x: 0, y: 0 });

// 保存当前位置到本地存储
function savePosition() {
  try {
    localStorage.setItem(
      FLOAT_POS_KEY,
      JSON.stringify({
        x: btnPosition.value.x,
        y: btnPosition.value.y,
      })
    );
  } catch (e) {
    // 忽略存储失败（如隐私模式）
  }
}

// 动态样式
const btnStyle = computed(() => ({
  left: `${btnPosition.value.x}px`,
  top: `${btnPosition.value.y}px`,
}));

// 指针按下开始拖拽（同时兼容鼠标与触屏）
function onPointerDown(e: PointerEvent) {
  // 鼠标仅响应左键，触屏/笔忽略按键判断
  if (e.pointerType === "mouse" && e.button !== 0) return;
  isDragging.value = true;
  dragStart.value = { x: e.clientX, y: e.clientY };
  startPos.value = { ...btnPosition.value };
  document.addEventListener("pointermove", onPointerMove);
  document.addEventListener("pointerup", onPointerUp);
  document.addEventListener("pointercancel", onPointerUp);
}

// 指针移动
function onPointerMove(e: PointerEvent) {
  if (!isDragging.value) return;
  const dx = e.clientX - dragStart.value.x;
  const dy = e.clientY - dragStart.value.y;
  btnPosition.value = {
    x: startPos.value.x + dx,
    y: startPos.value.y + dy,
  };
}

// 指针松开结束拖拽
function onPointerUp(e: PointerEvent) {
  isDragging.value = false;
  document.removeEventListener("pointermove", onPointerMove);
  document.removeEventListener("pointerup", onPointerUp);
  document.removeEventListener("pointercancel", onPointerUp);

  // 吸附到屏幕边缘
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const btnWidth = 56;
  const btnHeight = 56;

  // 水平方向吸附
  if (btnPosition.value.x < screenWidth / 2) {
    btnPosition.value.x = 20;
  } else {
    btnPosition.value.x = screenWidth - btnWidth - 20;
  }

  // 垂直方向限制
  if (btnPosition.value.y < 20) {
    btnPosition.value.y = 20;
  } else if (btnPosition.value.y > screenHeight - btnHeight - 20) {
    btnPosition.value.y = screenHeight - btnHeight - 20;
  }

  // 拖拽结束后保存位置，下次进入直接恢复到该位置
  savePosition();
}

// AI助手点击事件
function handleAiAssistantClick() {
  containerDrawerVisible.value = true;
}

// 云对话点击事件
function handleCloudChatClick() {
  message.warning(`云对话正在开发中！`);
  // createMessage.warn('云对话正在开发中');
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(shouldShow))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "global-float-btn",
          style: _normalizeStyle(_unref(btnStyle)),
          onPointerdown: onPointerDown
        }, [
          _createVNode(_component_a_tooltip, {
            placement: "topRight",
            title: "常见问题，AI智能解答"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "global-float-cont global-float-top",
                onClick: _withModifiers(handleAiAssistantClick, ["stop"])
              }, [
                _createElementVNode("img", {
                  src: _unref(global1),
                  alt: "Smiley face",
                  width: "32",
                  height: "32",
                  style: {"pointer-events":"none"}
                }, null, 8, _hoisted_2),
                _hoisted_3
              ], 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, {
            placement: "topRight",
            title: "轻松打字，语音对话就可以完成下单操作"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "global-float-cont",
                onClick: _withModifiers(handleCloudChatClick, ["stop"])
              }, [
                _createElementVNode("img", {
                  src: _unref(global2),
                  alt: "Smiley face",
                  width: "32",
                  height: "32",
                  style: {"pointer-events":"none"}
                }, null, 8, _hoisted_5),
                _hoisted_6
              ], 8, _hoisted_4)
            ]),
            _: 1
          })
        ], 36))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      visible: _unref(containerDrawerVisible),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(containerDrawerVisible) ? (containerDrawerVisible).value = $event : containerDrawerVisible = $event)),
      size: "large",
      class: "custom-class",
      title: "常见问题，AI智能解答",
      placement: "right",
      "body-style": { padding: '0px' }
    }, {
      default: _withCtx(() => [
        (_unref(containerDrawerVisible))
          ? (_openBlock(), _createElementBlock("iframe", _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})